import { ChangeDetectionStrategy, Component, input, computed } from '@angular/core';
import { IconNames } from '../../icons/icon-names';
import { Experiment } from 'src/app/_models/experiment';
import { SvgTemplateComponent } from '../../svg-template/svg-template.component';
import { DecimalPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-small-data-card',
    templateUrl: './small-data-card.component.html',
    styleUrls: ['./small-data-card.component.scss'],
    imports: [SvgTemplateComponent, DecimalPipe, DatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SmallDataCardComponent {
  /** The OD reading to display (required) */
  dataReading = input<number>();

  /** Temperature reading value (required) */
  temperatureReading = input<number>();

  /** Time string of the data reading (required) */
  dataReadingTime = input<string>();

  /** Experiment object for additional values (required) */
  experiment = input<Experiment>();

  /** Flask identifier ('Flask A' | 'Flask B' | 'Flask C' | 'Flask D') (required) */
  flask = input<'Flask A' | 'Flask B' | 'Flask C' | 'Flask D'>();

  /** Optional temperature display string (required)*/
  temperature = input<string>();

  /** Computed Date object from the dataReadingTime input */
  time = computed<Date | undefined>(() => {
    const s = this.dataReadingTime();
    return s ? new Date(s) : undefined;
  });

  public get flaskIcon(): string {
    switch (this.flask()) {
      case 'Flask A':
        return IconNames.FlaskA;
      case 'Flask B':
        return IconNames.FlaskB;
      case 'Flask C':
        return IconNames.FlaskC;
      case 'Flask D':
        return IconNames.FlaskD;
      default:
        return '';
    }
  }

  public get speedRPMReading(): number {
    switch (this.flask()) {
      case 'Flask A':
        return this.experiment().speedRPMA;
      case 'Flask B':
        return this.experiment().speedRPMB;
      case 'Flask C':
        return this.experiment().speedRPMC;
      case 'Flask D':
        return this.experiment().speedRPMD;
      default:
        return null;
    }
  }
}
